import { render, staticRenderFns } from "./NameListProfile.vue?vue&type=template&id=4af97371&scoped=true&"
import script from "./NameListProfile.vue?vue&type=script&lang=js&"
export * from "./NameListProfile.vue?vue&type=script&lang=js&"
import style0 from "./NameListProfile.vue?vue&type=style&index=0&id=4af97371&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af97371",
  null
  
)

export default component.exports